import React from 'react';
import PropTypes from 'prop-types';
import styles from '../DashboardPage/DashboardPage.module.scss';
import { LiveDataGrid } from '../../components/LiveDataGrid';
import { ATS_TRADE_SYMBOL_SUMMARY, ATS_TRADE_MMID_SUMMARY, ATS_QUOTE_SYMBOL_SUMMARY, ATS_QUOTE_MMID_SUMMARY,
  ATS_QUOTE_FREQ_SYMBOL_SUMMARY, ATS_QUOTE_FREQ_MMID_SUMMARY
} from '../../util/dashBoardPageConstants';
import getConfig from '../../config';
const { DASHBOARD_CONFIG } = getConfig();

const ATS_TRADE_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ATS_TRADE_SYMBOL_SUMMARY);
const ATS_TRADE_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ATS_TRADE_MMID_SUMMARY);

const ATS_QUOTE_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ATS_QUOTE_SYMBOL_SUMMARY);
const ATS_QUOTE_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ATS_QUOTE_MMID_SUMMARY);

const ATS_QUOTE_SYMBOL_FREQ_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ATS_QUOTE_FREQ_SYMBOL_SUMMARY);
const ATS_QUOTE_MMID_FREQ_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ATS_QUOTE_FREQ_MMID_SUMMARY);

class DashboardAtsGrids extends React.PureComponent {
  render () {
    const pauseRealTimeData = this.props.pauseRealTimeData;
    return (
      <div className={styles.atsTables} >
        <LiveDataGrid
          identifier={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.identifier}
          header={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.header}
          ws={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.ws}
          api={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.api}
          downloadApi={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20} />

        <LiveDataGrid
          identifier={ATS_TRADE_MMID_SUMMARY_CONFIG.identifier}
          header={ATS_TRADE_MMID_SUMMARY_CONFIG.header}
          ws={ATS_TRADE_MMID_SUMMARY_CONFIG.ws}
          api={ATS_TRADE_MMID_SUMMARY_CONFIG.api}
          downloadApi={ATS_TRADE_MMID_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={ATS_TRADE_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ATS_TRADE_MMID_SUMMARY_CONFIG.totalField}
          columns={ATS_TRADE_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ATS_TRADE_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ATS_TRADE_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20} />

        <LiveDataGrid
          identifier={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.identifier}
          header={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.header}
          ws={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.ws}
          api={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.api}
          downloadApi={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />

        <LiveDataGrid
          identifier={ATS_QUOTE_SYMBOL_FREQ_SUMMARY_CONFIG.identifier}
          header={ATS_QUOTE_SYMBOL_FREQ_SUMMARY_CONFIG.header}
          ws={ATS_QUOTE_SYMBOL_FREQ_SUMMARY_CONFIG.ws}
          api={ATS_QUOTE_SYMBOL_FREQ_SUMMARY_CONFIG.api}
          lastUpdatedField={ATS_QUOTE_SYMBOL_FREQ_SUMMARY_CONFIG.lastUpdatedField}
          columns={ATS_QUOTE_SYMBOL_FREQ_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ATS_QUOTE_SYMBOL_FREQ_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ATS_QUOTE_SYMBOL_FREQ_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />

        <LiveDataGrid
          identifier={ATS_QUOTE_MMID_SUMMARY_CONFIG.identifier}
          header={ATS_QUOTE_MMID_SUMMARY_CONFIG.header}
          ws={ATS_QUOTE_MMID_SUMMARY_CONFIG.ws}
          api={ATS_QUOTE_MMID_SUMMARY_CONFIG.api}
          downloadApi={ATS_QUOTE_MMID_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={ATS_QUOTE_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ATS_QUOTE_MMID_SUMMARY_CONFIG.totalField}
          columns={ATS_QUOTE_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ATS_QUOTE_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ATS_QUOTE_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />

        <LiveDataGrid
          identifier={ATS_QUOTE_MMID_FREQ_SUMMARY_CONFIG.identifier}
          header={ATS_QUOTE_MMID_FREQ_SUMMARY_CONFIG.header}
          ws={ATS_QUOTE_MMID_FREQ_SUMMARY_CONFIG.ws}
          api={ATS_QUOTE_MMID_FREQ_SUMMARY_CONFIG.api}
          lastUpdatedField={ATS_QUOTE_MMID_FREQ_SUMMARY_CONFIG.lastUpdatedField}
          columns={ATS_QUOTE_MMID_FREQ_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ATS_QUOTE_MMID_FREQ_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ATS_QUOTE_MMID_FREQ_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />
      </div>
    );
  }
}

export default DashboardAtsGrids;
export const MemoizedDashboardAtsGrids = React.memo(DashboardAtsGrids);

DashboardAtsGrids.propTypes = {
  pauseRealTimeData: PropTypes.bool
};
